// extracted by mini-css-extract-plugin
export var checkbox = "_9a-0";
export var circle = "_9a-3";
export var horizontalContainer = "_9a-7";
export var sm = "_9a-5";
export var switch0 = "_9a-2";
export var switchDisabled = "_9a-8";
export var switchEnabled = "_9a-1";
export var textSwitchContainer = "_9a-9";
export var textSwitchOption = "_9a-a";
export var textSwitchOptionSelected = "_9a-b";
export var verticalContainer = "_9a-6";
export var xs = "_9a-4";